@if (hasData()) {
  <div
    id="avenue-asset-list"
    fxLayoutAlign="center"
    fxLayout="column"
    fxFlex="100"
    >
    <!-- assignables section -->
    @if (assets) {
      <section class="avenue-asset-list-content-container">
        <!-- assignables -->
        @for (a of assets; track a) {
          <div class="avenue-asset-item" [ngClass]="{'deleted' : a.isDeleted}">
            <avenue-asset-item
              [asset]="a"
              [profile]="profile"
              [selectedAsset]="selectedAsset"
              (editAssetEvent)="editAsset($event)"
              (deleteAssetEvent)="deleteAsset($event)"
              (selectAsset)="onSelectAsset($event)"
              >
            </avenue-asset-item>
          </div>
        }
      </section>
    }
  </div>
}
@if (showLoadMoreButton()) {
  <button
    mat-raised-button
    color="primary"
    class="wide-button"
    (click)="loadMore()"
    >
    Load More
  </button>
}
@if (loadingBool) {
  <mat-spinner class="assetListSpinner"></mat-spinner>
}
@if (!hasData() && !loadingBool) {
  <no-search-results> </no-search-results>
}
